import type { IAbTest } from '@/interface/IAbTest';
import type { ICustomerInfo } from '@/interface/ICustomerInfo';
import { LicenseType, PlayerType, PriceStyle } from '@/interface/enum';
import type { CustomerInfo } from '@/interface/pollux';

export function formatCustomer(customerInfo: CustomerInfo): ICustomerInfo {
    return {
        currency: customerInfo.currency ?? '',
        isoCurrency: customerInfo.isoCurrency ?? '',
        siteStyle: customerInfo.siteStyle,
        priceStyle: PriceStyle.fromPollux(customerInfo.priceStyle),
        priceStyleOptions: customerInfo.priceStyleOptions?.map(x => PriceStyle.fromPollux(x)) ?? [],
        isAcceptAnyOdds: customerInfo.isAcceptAnyOdds,
        isAcceptAnyCashOutValue: customerInfo.isAcceptAnyCashOutValue,
        abTestGroup: formatAbTest(customerInfo.abTestGroup || {}),
        playerType: PlayerType.fromPollux(customerInfo.playerType),
        license: LicenseType.fromPollux(customerInfo.license),
        accountId: customerInfo.accountId,
        loginName: customerInfo.loginName ?? '',
        isQ: customerInfo.isQ,
        ipCountryCode: customerInfo.ipCountryCode ?? '',
        isEFootballEnabled: customerInfo.isEFootballEnabled,
        trackingId: customerInfo.trackingId ?? '',
        isSimulationEnabled: customerInfo.isSimulationEnabled,
    };
}

function formatAbTest(abTestGroup: Record<string, boolean>): Record<number, IAbTest> {
    return Object.keys(abTestGroup || {})
        .filter(key => !Number.isNaN(Number(key)))
        .reduce<Record<number, IAbTest>>((acc, key) => {
        acc[Number(key)] = { isUseNewFeature: !abTestGroup[key] };
        return acc;
    }, {});
}
